import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

const VirementPaymentMethod = ({
  numVirement,
  setNumeVirement,
  montantVirement,
  setMontantVirement,
  taxes,
  setTaxes,
  total,
  fraisVirement,
  note,
  setNote,
  file,
  setFile,
}: any) => {
  const { t } = useTranslation();

  useEffect(() => {
    const taxValue = parseFloat(taxes) || 0;
    setMontantVirement(total - (taxValue + parseFloat(fraisVirement)));
  }, [taxes, total, fraisVirement, setMontantVirement]);

  return (
    <div>
      <div className="navbar-item flex-row search-ul navbar-dropdown">
        <div className="nav-item align-self-center search-animated">
          <form
            className="form-inline search-full form-inline search"
            role="search"
          >
            <div
              className="search-bar"
              style={{ marginBottom: "7px", display: "flex" }}
            >
              <label
                style={{ width: "-webkit-fill-available", textAlign: "left" }}
              >
                Total:
              </label>
              <input
                type="text"
                className="form-control search-form-control ml-lg-auto"
                value={total}
                readOnly
              />
            </div>
            <div
              className="search-bar"
              style={{ marginBottom: "7px", display: "flex" }}
            >
              <label style={{ width: "-webkit-fill-available" }}>
                Frais Virement:
              </label>
              <input
                type="text"
                className="form-control search-form-control ml-lg-auto"
                value={fraisVirement}
                readOnly
              />
            </div>
            <div
              className="search-bar"
              style={{ marginBottom: "7px", display: "flex" }}
            >
              <label style={{ width: "-webkit-fill-available" }}>Taxes:</label>
              <input
                type="text"
                className="form-control search-form-control ml-lg-auto"
                value={taxes}
                onChange={(e) => {
                  const val = e.currentTarget.value;
                  // Only allow digits and one optional decimal
                  if (/^\d*\.?\d*$/.test(val)) {
                    setTaxes(val);
                  }
                }}
              />
            </div>
            <div
              className="search-bar"
              style={{ marginBottom: "7px", display: "flex" }}
            >
              <label style={{ width: "-webkit-fill-available" }}>
                Montant Virement:
              </label>
              <input
                type="text"
                className="form-control search-form-control ml-lg-auto"
                value={montantVirement.toFixed(2)}
                readOnly
              />
            </div>
            <div
              className="search-bar"
              style={{ marginBottom: "7px", display: "flex" }}
            >
              <label style={{ width: "-webkit-fill-available" }}>
                Numéro de Virement:
              </label>
              <input
                type="text"
                className="form-control search-form-control ml-lg-auto"
                value={numVirement}
                onChange={(e) => setNumeVirement(e.currentTarget.value)}
              />
            </div>
            <div
              className="search-bar"
              style={{ marginBottom: "7px", display: "flex" }}
            >
              <label style={{ width: "-webkit-fill-available" }}>Note:</label>
              <input
                type="text"
                className="form-control search-form-control ml-lg-auto"
                placeholder="Note ..."
                value={note}
                onChange={(e) => setNote(e.currentTarget.value)}
              />
            </div>
            <div
              className="search-bar"
              style={{ marginBottom: "7px", display: "flex" }}
            >
              <label style={{ width: "-webkit-fill-available" }}>Note:</label>
              <input
                type="file"
                className="form-control search-form-control ml-lg-auto"
                onChange={(e) => {
                  const selectedFile = e.currentTarget.files?.[0]; // accède au premier fichier
                  if (selectedFile) {
                    setFile(selectedFile);
                  }
                }}
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default VirementPaymentMethod;
